import { Link } from "react-router-dom";

/**
 * ============================================================================
 * "← Back to the documentary" — the one copy (D-107).
 * ============================================================================
 *
 * SEVEN PAGES CARRIED THIS LINK AND THREE OF THEM HAD DRIFTED. Not visibly, and
 * not in a way any gate on this site could see, which is D-102's whole point:
 * two surfaces drawing one thing diverge, and the fix is one component rather
 * than one correction.
 *
 *   · `/stories` had `text-muted`/`text-bright` where the other six had
 *     `accent-link`/`accent-link-hover`, so the site's only "go home" control
 *     did not look like a link on one page in seven — AND it was missing the
 *     `min-h-[24px]` the others carry, which is the part that made it a
 *     DEFECT rather than an inconsistency: measured **197x20** at 320px, under
 *     WCAG 2.2 SC 2.5.8's 24x24 floor. A responsive sweep across a real device
 *     matrix is what surfaced it; three widths never had.
 *   · `/projects` read "Back to the documentary" with **no arrow**, where the
 *     other six read "← Back to the documentary". One character, invisible
 *     unless the two pages are opened side by side.
 *   · `/achievements` had no back link AT ALL — the only content route
 *     without one.
 *
 * `inline-flex` + `items-center` + `min-h-[24px]`, copied from
 * `WorkshopDetail`'s breadcrumb, which had already reached this shape. Plain
 * `inline-block` with a min-height also clears 24px, but it puts the text at
 * the top of the box and the extra height below it as dead space; centring
 * means the pixels a finger is aiming at are the pixels the eye is aiming at.
 *
 * THE ARROW IS `aria-hidden`. "left arrow Back to the documentary" is what a
 * screen reader says otherwise, and the arrow is decoration — the link text
 * already says where it goes.
 *
 * IT RENDERS THE LINK AND NOT ITS WRAPPER, deliberately. Four call sites put it
 * in a row beside a sibling link ("Client projects →"), three centre it alone
 * under the content. That is genuinely surface-specific layout, and a component
 * that owned the wrapper would have to grow a prop to express it — which is the
 * shape D-102 warns about from the other side.
 */
export default function BackToDocumentary(): JSX.Element {
	return (
		<Link
			to="/"
			className="inline-flex min-h-[24px] items-center text-sm font-medium text-[var(--accent-link)] transition-colors duration-200 hover:text-[var(--accent-link-hover)]"
		>
			<span aria-hidden="true">←&nbsp;</span>Back to the documentary
		</Link>
	);
}
